
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function MobileMoneyPage() {
  const [selectedProvider, setSelectedProvider] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [amount, setAmount] = useState('');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentStep, setPaymentStep] = useState(1);

  const mobileMoneyProviders = [
    { 
      id: 'orange', 
      name: 'Orange Money', 
      icon: 'ri-smartphone-line', 
      color: 'bg-orange-500',
      countries: ['Côte d\'Ivoire', 'Sénégal', 'Mali', 'Burkina Faso'],
      fees: '1%',
      limits: '1,000,000 FCFA/jour'
    },
    { 
      id: 'mtn', 
      name: 'MTN Money', 
      icon: 'ri-smartphone-line', 
      color: 'bg-yellow-500',
      countries: ['Côte d\'Ivoire', 'Ghana', 'Ouganda', 'Rwanda'],
      fees: '1.2%',
      limits: '500,000 FCFA/jour'
    },
    { 
      id: 'moov', 
      name: 'Moov Money', 
      icon: 'ri-smartphone-line', 
      color: 'bg-blue-500',
      countries: ['Côte d\'Ivoire', 'Burkina Faso', 'Togo', 'Bénin'],
      fees: '0.8%',
      limits: '750,000 FCFA/jour'
    },
    { 
      id: 'mpesa', 
      name: 'M-Pesa', 
      icon: 'ri-smartphone-line', 
      color: 'bg-green-500',
      countries: ['Kenya', 'Tanzanie', 'Ouganda', 'Rwanda'],
      fees: '1.5%',
      limits: '300,000 KES/jour'
    },
    { 
      id: 'airtel', 
      name: 'Airtel Money', 
      icon: 'ri-smartphone-line', 
      color: 'bg-red-500',
      countries: ['Kenya', 'Ouganda', 'Tanzanie', 'Zambie'],
      fees: '1.3%',
      limits: '200,000 KES/jour'
    }
  ];

  const recentTransactions = [
    {
      id: '1',
      type: 'Paiement livraison',
      amount: '2,500 FCFA',
      provider: 'Orange Money',
      date: '15 Nov 2024',
      status: 'Réussi',
      reference: 'OM-2024-001'
    },
    {
      id: '2',
      type: 'Rechargement compte',
      amount: '10,000 FCFA',
      provider: 'MTN Money',
      date: '14 Nov 2024',
      status: 'Réussi',
      reference: 'MTN-2024-002'
    },
    {
      id: '3',
      type: 'Paiement livraison',
      amount: '3,500 FCFA',
      provider: 'Moov Money',
      date: '13 Nov 2024',
      status: 'Réussi',
      reference: 'MV-2024-003'
    }
  ];

  const handlePayment = () => {
    if (!selectedProvider || !phoneNumber || !amount) return;
    setShowPaymentModal(true);
    setPaymentStep(1);
  };

  const processPayment = () => {
    setPaymentStep(2);
    // Simulation du processus de paiement
    setTimeout(() => {
      setPaymentStep(3);
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4">
              <Link to="/" className="text-2xl font-bold text-teal-600" style={{ fontFamily: 'Pacifico, serif' }}>
                ONAPILA
              </Link>
              <span className="text-gray-400">|</span>
              <span className="text-gray-600 font-medium">Mobile Money</span>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <i className="ri-shield-check-line text-green-500"></i>
                <span>Paiements sécurisés</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8">
            {/* Sélection du fournisseur */}
            <div className="bg-white rounded-2xl shadow-sm p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Choisir votre fournisseur Mobile Money</h2>
              
              <div className="grid md:grid-cols-2 gap-4 mb-8">
                {mobileMoneyProviders.map((provider) => (
                  <div
                    key={provider.id}
                    onClick={() => setSelectedProvider(provider.id)}
                    className={`p-6 border rounded-xl cursor-pointer transition-all ${
                      selectedProvider === provider.id
                        ? 'border-teal-500 bg-teal-50 shadow-md'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className="flex items-center space-x-4 mb-4">
                      <div className={`w-12 h-12 ${provider.color} rounded-lg flex items-center justify-center`}>
                        <i className={`${provider.icon} text-white text-xl`}></i>
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900">{provider.name}</h3>
                        <p className="text-sm text-gray-600">Frais : {provider.fees}</p>
                      </div>
                      {selectedProvider === provider.id && (
                        <div className="ml-auto">
                          <i className="ri-check-line text-teal-600 text-xl"></i>
                        </div>
                      )}
                    </div>
                    
                    <div className="space-y-2 text-sm text-gray-600">
                      <div className="flex justify-between">
                        <span>Limite journalière :</span>
                        <span className="font-medium">{provider.limits}</span>
                      </div>
                      <div>
                        <span>Pays : </span>
                        <span className="font-medium">{provider.countries.join(', ')}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Formulaire de paiement */}
              {selectedProvider && (
                <div className="border-t border-gray-200 pt-8">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Effectuer un paiement</h3>
                  
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Numéro de téléphone
                      </label>
                      <input
                        type="tel"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        placeholder="Ex: +225 07 12 34 56 78"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Montant (FCFA)
                      </label>
                      <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="Ex: 2500"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                      />
                    </div>
                  </div>

                  <button
                    onClick={handlePayment}
                    disabled={!phoneNumber || !amount}
                    className="w-full mt-6 bg-teal-600 text-white py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-smartphone-line mr-2"></i>
                    Payer avec {mobileMoneyProviders.find(p => p.id === selectedProvider)?.name}
                  </button>
                </div>
              )}
            </div>

            {/* Historique des transactions */}
            <div className="bg-white rounded-2xl shadow-sm p-8">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-bold text-gray-900">Historique des transactions</h3>
                <button className="text-teal-600 hover:text-teal-700 font-medium">
                  Voir tout
                </button>
              </div>

              <div className="space-y-4">
                {recentTransactions.map((transaction) => (
                  <div key={transaction.id} className="p-4 border border-gray-200 rounded-xl hover:shadow-md transition-shadow">
                    <div className="flex justify-between items-start mb-3">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                          <i className="ri-smartphone-line text-green-600"></i>
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-900">{transaction.type}</h4>
                          <p className="text-sm text-gray-600">{transaction.provider}</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="font-semibold text-gray-900">{transaction.amount}</p>
                        <span className="inline-block px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full font-medium">
                          {transaction.status}
                        </span>
                      </div>
                    </div>
                    
                    <div className="flex justify-between items-center text-sm text-gray-500">
                      <span>{transaction.date}</span>
                      <span>Réf: {transaction.reference}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Avantages Mobile Money */}
            <div className="bg-white rounded-2xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">Pourquoi Mobile Money ?</h3>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-user-line text-orange-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Accessible à tous</h4>
                    <p className="text-sm text-gray-600">Pas besoin de compte bancaire</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-flashlight-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Instantané</h4>
                    <p className="text-sm text-gray-600">Paiements en temps réel</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-shield-check-line text-green-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Sécurisé</h4>
                    <p className="text-sm text-gray-600">Chiffrement et authentification</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-money-dollar-circle-line text-purple-600 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Frais réduits</h4>
                    <p className="text-sm text-gray-600">Tarifs négociés avec ONAPILA</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Statistiques */}
            <div className="bg-white rounded-2xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">Vos statistiques</h3>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Transactions ce mois</span>
                  <span className="font-semibold text-gray-900">12</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Montant total</span>
                  <span className="font-semibold text-gray-900">45,500 FCFA</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Frais payés</span>
                  <span className="font-semibold text-gray-900">455 FCFA</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Économies réalisées</span>
                  <span className="font-semibold text-green-600">1,200 FCFA</span>
                </div>
              </div>
            </div>

            {/* Support */}
            <div className="bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl p-6 text-white">
              <h3 className="text-lg font-bold mb-2">Besoin d'aide ?</h3>
              <p className="text-orange-100 mb-4 text-sm">
                Notre équipe support Mobile Money est disponible 24h/24
              </p>
              <button className="w-full bg-white text-orange-600 py-2 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-customer-service-line mr-2"></i>
                Contacter le support
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de paiement */}
      {showPaymentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-8">
            {paymentStep === 1 && (
              <>
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-smartphone-line text-orange-600 text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">Confirmer le paiement</h3>
                  <p className="text-gray-600">Vérifiez les détails de votre transaction</p>
                </div>

                <div className="space-y-4 mb-6">
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">Fournisseur</span>
                    <span className="font-semibold">{mobileMoneyProviders.find(p => p.id === selectedProvider)?.name}</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">Numéro</span>
                    <span className="font-semibold">{phoneNumber}</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">Montant</span>
                    <span className="font-semibold text-lg">{amount} FCFA</span>
                  </div>
                </div>

                <div className="flex space-x-3">
                  <button 
                    onClick={() => setShowPaymentModal(false)}
                    className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Annuler
                  </button>
                  <button 
                    onClick={processPayment}
                    className="flex-1 px-4 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Confirmer
                  </button>
                </div>
              </>
            )}

            {paymentStep === 2 && (
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-refresh-line text-blue-600 text-2xl animate-spin"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Traitement en cours</h3>
                <p className="text-gray-600 mb-6">Veuillez patienter pendant le traitement de votre paiement...</p>
                <div className="bg-blue-50 rounded-lg p-4">
                  <p className="text-blue-700 text-sm">
                    <i className="ri-information-line mr-1"></i>
                    Vous allez recevoir un SMS de confirmation de votre opérateur
                  </p>
                </div>
              </div>
            )}

            {paymentStep === 3 && (
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-green-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Paiement réussi !</h3>
                <p className="text-gray-600 mb-6">Votre transaction a été effectuée avec succès</p>
                
                <div className="bg-green-50 rounded-lg p-4 mb-6">
                  <div className="text-sm text-green-700">
                    <div className="flex justify-between mb-2">
                      <span>Référence :</span>
                      <span className="font-semibold">OM-2024-{Date.now().toString().slice(-6)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Montant :</span>
                      <span className="font-semibold">{amount} FCFA</span>
                    </div>
                  </div>
                </div>

                <button 
                  onClick={() => setShowPaymentModal(false)}
                  className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Terminer
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
